export const HeaderData = [
  {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
    heading: "Get Everything About Us",
  },
  {
    title: "Classes",
    path: "#",
    subNav: [
      {
        subTitle: "Classes",
        heading: " TRooYoga Offer Classes ",
        path: "/Home/Classes",
      },
      {
        subTitle: "Classes Lists",
        heading: "TRooYoga Offer Classes",
        path: "/Home/Classes_Lists",
      },
      {
        subTitle: "Classes Details",
        heading: "Yoga To Realize And Love Yourself",
        path: "/Home/Classes/Classes_Details",
      },
    ],
  },
  {
    title: "Other Pages",
    path: "#",
    subNav: [
      {
        subTitle: "Our Team",
        heading: "View Our Awesome Team",
        path: "/Home/Our_Team",
      },

      {
        subTitle: "Client Reviews",
        heading: "Our Awesome Client’s Review",
        path: "/Home/Client_Reviews",
      },

      {
        subTitle: "FAQ",
        heading: "Common Queries",
        path: "/Home/FAQ",
      },
      {
        subTitle: "Pricing Table",
        heading: "Our Best Plans For You",
        path: "/Home/Pricing_Table",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        path: "/Home/Comming_Soon",
      },
      {
        subTitle: "Error 404",
        heading: "404 Error",
        path: "/Home/Error_404",
      },
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Blogs",
        heading: "News for nerds, stuff that matters",
        path: "/Home/Blogs",
      },
      {
        subTitle: "Blog Lists",
        heading: "News for nerds, stuff that matters",
        path: "/Home/Blog_Lists",
      },
      {
        subTitle: "Blog Details",
        heading: "Supplements & Herbs / When & Why to Take Them",
        path: "/Home/Blogs/Blog_Details",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/Home/Contact_Us",
    heading: "We are Happy to Help You",
  },
  {
    title: "BOOK A CLASS",
    heading: "Book an Appointment",
    path: "/Home/BOOK_A_CLASS",
  },
];
